module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "seckill-icon",
    style: (_vm.custom)
  }, [_c('i', [_vm._v(_vm._s(_vm.tag))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1b058f92", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b058f92"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SeckillIcon/index.vue
// module id = 282
// module chunks = 8